import { render, staticRenderFns } from "./SuportPageERP.vue?vue&type=template&id=a3af4f3a&"
import script from "./SuportPageERP.vue?vue&type=script&lang=js&"
export * from "./SuportPageERP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3af4f3a')) {
      api.createRecord('a3af4f3a', component.options)
    } else {
      api.reload('a3af4f3a', component.options)
    }
    module.hot.accept("./SuportPageERP.vue?vue&type=template&id=a3af4f3a&", function () {
      api.rerender('a3af4f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/faq/SuportPageERP.vue"
export default component.exports